import React, { useEffect, useState } from "react";
import DayView from "./ComponentsCalendarView/DayView";
import WeekView from "./ComponentsCalendarView/WeekView";
import MonthView from "./ComponentsCalendarView/MonthView";
import HeaderControls from "./ComponentsCalendarView/HeaderControls";
import { getPerfilMedico } from "../../../../services/usuarios"; // ajusta si tu ruta difiere

const CalendarView = ({selectedDate,onDateChange,view,setActiveView,setMostrarModal,setCitaSeleccionada,refresh,setRefresh,}) => {
  const [horario, setHorario] = useState({});

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getPerfilMedico();   // GET /api/perfil/
        if (mounted) setHorario(data?.horario || {});
      } catch (e) {
        console.error("No se pudo cargar el perfil/horario:", e);
        if (mounted) setHorario({});
      }
    })();
    return () => { mounted = false; };
  }, [refresh]); // ← cuando cambie refresh, recarga horario

  return (
    <div className="calendar-view">
      <HeaderControls
        selectedDate={selectedDate}
        setSelectedDate={onDateChange}
        view={view}
        setView={setActiveView}
      />
      <div className="calendar-section2">
        {view === "day" && (
          <DayView
            selectedDate={selectedDate}
            refresh={refresh}
            setRefresh={setRefresh}
            horario={horario}
          />
        )}
        {view === "week" && (
          <WeekView
            selectedDate={selectedDate}
            refresh={refresh}
            setRefresh={setRefresh}
            horario={horario}   // opcional si luego pintas gris en semana
          />
        )}
        {view === "month" && (
          <MonthView
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            setActiveView={setActiveView}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        )}
      </div>
    </div>
  );
};

export default CalendarView;
